"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var deepmerge_1 = __importDefault(require("deepmerge"));
// tslint:disable-next-line: arrow-return-shorthand
exports.skeletonTheme = function (theme) {
    var componentTheme = {
        /* background color of the box */
        background: theme.greyLight.color.normal,
        /* color of the sliding effect */
        effectColor: '#fafafa',
        /* Border color */
        borderColor: 'transparent',
        /* border radius css prop */
        borderRadius: '3px',
        animation: {
            duration: '5s',
            timingFunction: 'cubic-bezier(0.13, 1, 0.83, 1.13)',
        },
    };
    if (theme.component.skeleton) {
        componentTheme = deepmerge_1.default(componentTheme, theme.component.skeleton);
    }
    return __assign(__assign({}, theme), { component: __assign(__assign({}, theme.component), { skeleton: componentTheme }) });
};
exports.default = exports.skeletonTheme;
//# sourceMappingURL=theme.js.map